module.exports = __webpack_public_path__ + "static/media/handshake-white.ba38f4cc.svg";